import { Text } from '@blueprint/ui';
import Link from 'next/link';
import React from 'react';
import {
    ListingCounts,
    ListingImagePreview
} from 'listing-details/components/shared';
import {
    ListingAddress,
    ListingPreviewLink,
    ListingPreviewContainer,
    ListingPriceContainer,
    ListingPreviewBranchLink,
    BranchImg,
    BranchDetails,
    BranchAddress
} from './ListingPreview.styles';
import {
    hasPriceQualifierLabel,
    mapPropertyImageResponseToGalleryImages
} from 'listing-details/helpers';
import { ListingPreviewProps } from './ListingPreview.types';
import {
    trackPreviewBranchClick,
    trackPreviewDescriptionClick,
    trackPreviewImgClick
} from './ListingPreview.tracking';
import ListingTags from '../ListingTags/ListingTags';

const ListingPreview = ({
    listing: {
        branch: { address, name, branchDetailsUri, logoUrl },
        counts,
        displayAddress,
        pricing,
        propertyImage,
        statusSummary,
        title
    },
    detailsUri
}: ListingPreviewProps) => {
    const listingImg = mapPropertyImageResponseToGalleryImages(
        '(min-width: 960px) 440px, 50vw',
        propertyImage || [],
        ['original']
    )[0];

    const details = detailsUri ? detailsUri : '';
    const { label: priceLabel } = pricing;

    return (
        <ListingPreviewContainer data-testid="listing-preview">
            <Link href={details} passHref>
                <ListingPreviewLink
                    onClick={trackPreviewImgClick}
                    data-testid="listing-preview-image"
                >
                    <ListingImagePreview image={listingImg} />
                </ListingPreviewLink>
            </Link>

            <Link href={details} passHref>
                <ListingPreviewLink
                    onClick={trackPreviewDescriptionClick}
                    data-testid="listing-preview-description"
                >
                    {hasPriceQualifierLabel(pricing.priceQualifierLabel) ? (
                        <Text data-testid="price-qualifier">
                            {pricing.priceQualifierLabel}
                        </Text>
                    ) : null}
                    <ListingPriceContainer>
                        <Text isBold size="3">
                            {priceLabel}
                        </Text>
                        <ListingTags data={{ statusSummary }} />
                    </ListingPriceContainer>
                    <Text isBold size="5">
                        {title}
                    </Text>
                    <ListingAddress>{displayAddress}</ListingAddress>
                    <ListingCounts data={counts} />
                </ListingPreviewLink>
            </Link>

            <Link href={branchDetailsUri || ''} passHref>
                <ListingPreviewBranchLink
                    onClick={trackPreviewBranchClick}
                    data-testid="listing-preview-branch"
                >
                    <BranchDetails>
                        <Text size="6" isBold>
                            {name}
                        </Text>
                        {address?.length && (
                            <BranchAddress>{address}</BranchAddress>
                        )}
                    </BranchDetails>
                    {logoUrl?.length && <BranchImg src={logoUrl} />}
                </ListingPreviewBranchLink>
            </Link>
        </ListingPreviewContainer>
    );
};

export default ListingPreview;
